import {
  SET_SHOW_ERROR,
  SET_ERROR_MESSAGE,
  SET_ERROR_TITLE,
  SET_REDIRECT_PAGE_ON_ERROR,
  SET_REDIRECT_PAGE_ON_ERROR_MESSAGE,
  SET_BLOCK_EMAIL_SUBMISSION
} from './types';

export default {
  [SET_SHOW_ERROR](state, payload) {
    state.showError = payload;
  },

  [SET_ERROR_MESSAGE](state, payload) {
    state.errorMessage = payload;
  },

  [SET_ERROR_TITLE](state, payload) {
    state.errorTitle = payload;
  },

  [SET_REDIRECT_PAGE_ON_ERROR](state, payload) {
    state.redirectPageOnError = payload;
  },

  [SET_REDIRECT_PAGE_ON_ERROR_MESSAGE](state, payload) {
    state.redirectPageOnErrorMessage = payload;
  },

  [SET_BLOCK_EMAIL_SUBMISSION](state, payload) {
    state.blockEmailSubmission = payload;
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/errors/mutations.js